<div class="page">
  <div class="card">
    <div class="header">
      <h3>{{ "ui.label.login.closing" | translate }}</h3>
    </div>
    <div class="body"></div>
  </div>
</div>
